var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.70818 0.322021C1.06054 0.322021 0.535156 0.835535 0.535156 1.46959C0.535156 2.10365 1.06012 2.62904 1.70732 2.62904C2.35451 2.62904 2.88034 2.10365 2.88034 1.46959C2.88034 0.835969 2.35583 0.322021 1.70818 0.322021ZM7.43113 3.3641C6.44613 3.3641 5.88254 3.86841 5.6122 4.36992H5.58359V3.49906H3.64242V9.88283H5.66509V6.72277C5.66509 5.89011 5.72929 5.08545 6.78176 5.08545C7.81914 5.08545 7.83428 6.03487 7.83428 6.7754V9.88283H9.85435H9.85695V6.37647C9.85695 4.66074 9.48015 3.3641 7.43113 3.3641ZM0.696415 3.49906V9.88283H2.72082V3.49906H0.696415Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.a06f7fbab784bebcaefb988af5449e8b.svg";
export { ForwardRef as ReactComponent };